<template>
  <div class="row">
    <!-- <h3 class="mb-20">Statistiques Générals</h3> -->
    <div class="col-md-3 col-sm-6" >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-primary"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
               Total Utilisateurs
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ data?.Totalusers }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3 col-sm-6" >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-danger"
            >
              <i class="flaticon-users-group"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
               Total Clients
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ data?.Totalclients }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-md-3 col-sm-6" >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-success"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
               Total Colis
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ data?.Totalcolis }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-md-3 col-sm-6" >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-info"
            >
              <i class="flaticon-cube-3d"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
               Total colis ramassés
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ data?.TotalRamasse }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-md-3 col-sm-6" >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-warning"
            >
              <i class="flaticon-parcel"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
               Total produits stock
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ data?.TotalProduits }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-md-3 col-sm-6" >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-warning"
            >
              <i class="flaticon-draft"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
               Total bons de réception
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ data?.TotalBonRecetion }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-md-3 col-sm-6" >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-primary"
            >
              <i class="flaticon-document"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
               Total bons de livraison
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ data?.TotalBL }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-md-3 col-sm-6" >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-secondary"
            >
              <i class="flaticon-document"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
               Total bons de livraison en stock
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ data?.TotalBLStock }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-md-3 col-sm-6" >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-danger"
            >
              <i class="flaticon-telegram"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
               Total bons d'envoi
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ data?.TotalBENV }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-md-3 col-sm-6" >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-success"
            >
              <i class="flaticon-notes"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
               Total bons de distribution
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ data?.TotalBDisctr }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-md-3 col-sm-6" >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-warning"
            >
              <i class="flaticon-fast-delivery"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
               Total bons de paiment (Livreur)
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ data?.TotalBonPaie }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-md-3 col-sm-6" >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-danger"
            >
              <i class="flaticon-fast-delivery"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
               Total bons de paiment (Zone)
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ data?.TotalBonZPaie }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-md-3 col-sm-6" >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-info"
            >
              <i class="flaticon-user"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
               Total bons de retour (Client)
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ data?.TotalBonRetourCust }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-md-3 col-sm-6" >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-primary"
            >
              <i class="flaticon-project"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
               Total bons de retour (Agence)
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ data?.TotalBonRetourAgence }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-md-3 col-sm-6" >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-success"
            >
              <i class="flaticon-money"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
               Total factures
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ data?.TotalInvoices }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

     
    <div class="col-md-3 col-sm-6" >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-info"
            >
              <i class="flaticon-money"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
               Total virement
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ data?.TotalTransfer }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

     
    <div class="col-md-3 col-sm-6" >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-danger"
            >
              <i class="flaticon-information"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
               Total Réclamations
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ data?.TotalClaim }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

     
    <div class="col-md-3 col-sm-6" >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-danger"
            >
              <i class="flaticon-form"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
               Total demandes de retour
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ data?.TotalRtnRequest }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

     
    <div class="col-md-3 col-sm-6" >
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-primary"
            >
              <i class="flaticon-information"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
               Total demandes de ramassage
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ data?.TotalPickRequest }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import statsBoxes from "./statsBoxes.json";

export default defineComponent({
  name: "StatsBoxes",
  props: {
    dashData: {
      type: Object,
      required: true
    }
  },
  data(props) {
    return {
      data: props.dashData,
      stats: statsBoxes,
    };
  },
});
</script>